import { IonCard, IonCardContent, IonCol, IonRow, IonSelectOption, IonText } from '@ionic/react';
import {
    bookOutline,
    briefcaseOutline,
    globeOutline,
    informationCircleOutline,
    logoInstagram,
    personOutline,
} from 'ionicons/icons';

import CheckBoxItem from '../../../components/checkbox/CheckBoxItem';
import InputItem from '../../../components/input/InputItem';
import SlideContent from '../../../components/slide-content/SlideContent';
import HR from '../../../layouts/HR';
import RadioItem from '../../../components/radio/RadioItem';

interface Props {
    formProvider: any
}

const Section3: React.FC<Props> = (props) => {
    return <SlideContent type="navbar" class="section3">
        <IonCard>
            <IonCardContent>
                <IonRow>
                    <IonCol>
                        <h3 className="ion-padding-bottom">تکمیل موارد زیر اختیاری است.</h3>

                        <InputItem name="martial" type="select2" label="وضعیت تاهل" icon={personOutline} maxlength={25} provider={props.formProvider}>
                            <RadioItem value="0" label='مجرد' isChecked={props.formProvider.form.martial.value == "0"}/>
                            <RadioItem value="1" label='متاهل' isChecked={props.formProvider.form.martial.value == "1"}/>
                        </InputItem>

                        <InputItem name="education_level" type="select2" label="سطح تحصیلات" icon={personOutline} maxlength={30} provider={props.formProvider}>
                            <RadioItem value="0" label='سیکل' isChecked={props.formProvider.form.education_level.value == "0"}/>
                            <RadioItem value="1" label='دیپلم' isChecked={props.formProvider.form.education_level.value == "1"}/>
                            <RadioItem value="2" label='کاردانی' isChecked={props.formProvider.form.education_level.value == "2"}/>
                            <RadioItem value="3" label='کارشناسی' isChecked={props.formProvider.form.education_level.value == "3"}/>
                            <RadioItem value="4" label='کارشناسی ارشد' isChecked={props.formProvider.form.education_level.value == "4"}/>
                            <RadioItem value="5" label='دکترا' isChecked={props.formProvider.form.education_level.value == "5"}/>
                        </InputItem>

                        <InputItem name="field_study" type="text" label="رشته تحصیلی" icon={bookOutline} maxlength={30} provider={props.formProvider} />

                        <InputItem name="job" type="text" label="شغل" icon={briefcaseOutline} maxlength={30} provider={props.formProvider} />

                        <InputItem name="website" type="text" label="آدرس وب سایت / وبلاگ" icon={globeOutline} maxlength={100} provider={props.formProvider} ltr spaced />

                        <InputItem name="instagram" type="text" label="آیدی پیج اینستاگرام" icon={logoInstagram} maxlength={50} provider={props.formProvider} ltr spaced />

                        <HR className="ion-margin-top ion-margin-bottom" />

                        <IonText className="head-text">غیر از کمک مستقیم مالی چگونه می توانید در پروژه ها مشارکت داشته باشید؟ با ذکر جزئیات توضیح دهید.</IonText>
                        <IonText className="sub-text">در صورت اجرای پروژه در استان شما، طبق مواردی که در این قسمت درج می کنید با شما تماس گرفته خواهد شد. هر لحظه می توانید مندرجات این کادر را ویرایش کنید.</IonText>
                        <IonText className="sub-text">مانند خودرو، اتوبوس، مینی بوس، موتورسیکلت، وانت، کامیون و ...</IonText>

                        <InputItem name="other" type="textarea" label="" icon={informationCircleOutline} maxlength={50} rows={4} provider={props.formProvider} />

                        <HR className="ion-margin-top ion-margin-bottom" />

                        <IonText className="head-text">علاقمند به فعالیت در تیم های ...</IonText>

                        <IonRow>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="research" key="research" label="پژوهشی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="public_relations" key="public_relations" label="روابط عمومی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="religious" key="religious" label="مذهبی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="developmental" key="developmental" label="عمرانی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="graphics" key="graphics" label="گرافیک" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="veterinary" key="veterinary" label="دامپزشکی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="ladies" key="ladies" label="بانوان" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="children" key="children" label="کودکان" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="legal" key="legal" label="حقوقی" provider={props.formProvider} />
                            </IonCol>
                            <IonCol size="6" className="ion-no-padding">
                                <CheckBoxItem name="documentation" key="documentation" label="مستندسازی" provider={props.formProvider} />
                            </IonCol>
                        </IonRow>

                        <IonText className="head-text">تخصص و تجربیات خود را با موضوع تیم های انتخابی فوق شرح دهید.</IonText>

                        <InputItem name="cooperation" type="textarea" label="" icon={informationCircleOutline} maxlength={50} rows={4} provider={props.formProvider} />
                    </IonCol>
                </IonRow>
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Section3